import { OperationOutcomeError } from "@medplum/core";

/**
 * True when `error` is the server's answer to a JSON patch whose `test` operation failed, for
 * example a `test /meta/versionId` that no longer matches the stored version.
 *
 * @param error - Value thrown by `patchResource`
 * @returns true when the first issue is an `invalid` outcome with "Test failed" in its text
 */
export function isPatchTestFailedError(error: unknown): boolean {
  if (!(error instanceof OperationOutcomeError)) return false;
  const issue = error.outcome.issue?.[0];
  return issue?.code === "invalid" && issue.details?.text?.includes("Test failed") === true;
}
